
import ServiceDetailLayout from '../../../components/feature/ServiceDetailLayout';

export default function RenovationPage() {
  return (
    <ServiceDetailLayout
      heroTitle="院舍改善工程"
      heroSubtitle="專業規劃設計，打造安全舒適的院舍環境，提升整體服務質素"
      heroImage="https://public.readdy.ai/ai/img_res/1d6a543004c295f2f36c1aacfccf0edc.jpg"
      breadcrumbs={[
        { name: '首頁', href: '/' },
        { name: '服務項目', href: '/#services' },
        { name: '院舍改善工程', href: '/services/renovation' },
      ]}
      overviewTitle="院舍改善工程"
      overviewDescription="康顧提供一站式院舍改善工程服務，從空間規劃、牌照申請到工程施工，全程由專業團隊跟進。我們深明院舍的運作需要及法例要求，能夠在符合規格的前提下，為院舍打造安全、舒適、實用的環境，提升整體服務質素及競爭力。"
      overviewImage="https://readdy.ai/api/search-image?query=Professional%20Hong%20Kong%20Chinese%20architect%20and%20contractor%20discussing%20renovation%20plans%20with%20nursing%20home%20manager%20in%20bright%20modern%20facility%2C%20blueprints%20on%20table%2C%20safety%20features%20visible%2C%20clean%20professional%20setting%2C%20natural%20daylight%2C%20simple%20background&width=800&height=600&seq=renovation-overview-001&orientation=landscape"
      overviewHighlights={[
        '熟悉社會福利署及消防處的牌照要求',
        '專業建築師及工程團隊',
        '一站式服務減少溝通成本',
        '可在不停運的情況下分階段施工',
        '協助申請改善工程資助',
        '提供工程後保養服務',
      ]}
      serviceDetails={[
        {
          icon: 'ri-layout-line',
          name: '空間規劃設計',
          description: '由專業建築師及室內設計師，按院舍的實際需要及法例要求，設計最佳的空間佈局。',
          features: [
            '實地視察及需求分析',
            '空間優化方案設計',
            '無障礙設施規劃',
            '消防及安全設計',
            '3D 效果圖製作',
            '工程預算評估',
          ],
        },
        {
          icon: 'ri-file-shield-2-line',
          name: '牌照申請顧問',
          description: '協助院舍處理牌照申請及續牌事宜，確保符合社會福利署及相關部門的要求。',
          features: [
            '牌照要求評估',
            '準備申請文件',
            '圖則設計及提交',
            '跟進部門查詢',
            '協調驗收視察',
            '持續合規支援',
          ],
        },
        {
          icon: 'ri-hammer-line',
          name: '工程施工管理',
          description: '由經驗豐富的工程團隊負責施工，確保工程質素、進度及安全。',
          features: [
            '持牌承建商施工',
            '工程進度管理',
            '質量監控檢查',
            '安全措施管理',
            '減少對院舍運作影響',
            '完工後清潔及驗收',
          ],
        },
      ]}
      pricingTitle="服務收費方案"
      pricingPlans={[
        {
          name: '顧問服務',
          price: 'HK$15,000',
          note: '起 · 只需專業意見及設計',
          features: [
            '實地視察評估',
            '改善方案建議',
            '平面圖及效果圖',
            '工程預算評估',
            '牌照要求諮詢',
            '不包括實際施工',
          ],
          highlighted: false,
        },
        {
          name: '小型改善工程',
          price: 'HK$80,000',
          note: '起 · 適合局部翻新或設施改善',
          features: [
            '包括設計及施工',
            '無障礙設施安裝',
            '消防系統改善',
            '照明及通風改善',
            '地板及牆身翻新',
            '工程期約 2-4 週',
          ],
          highlighted: true,
        },
        {
          name: '全面翻新工程',
          price: '面議',
          note: '大型翻新或新院舍籌備',
          features: [
            '全面規劃設計',
            '牌照申請全程支援',
            '整體翻新施工',
            '機電系統更新',
            '傢俬設備採購',
            '分階段施工安排',
          ],
          highlighted: false,
        },
      ]}
      faqs={[
        {
          question: '工程期間院舍需要停運嗎？',
          answer: '不一定需要。我們有豐富的經驗在院舍運作期間進行工程，會採用分階段施工的方式，盡量減少對日常運作的影響。我們會與院舍協調，安排在長者休息時間或分區進行工程，並做好安全隔離措施。',
        },
        {
          question: '如何確保符合牌照要求？',
          answer: '我們的團隊非常熟悉社會福利署《安老院實務守則》及相關法例要求。在設計階段已會充分考慮所有規格，包括人均面積、走火通道、消防設備等。我們也會在施工前與相關部門溝通，確保設計獲得認可。',
        },
        {
          question: '可以申請政府資助嗎？',
          answer: '可以。合資格的院舍可申請「改善買位計劃院舍設施資助計劃」，資助額最高可達核准工程費用的 80%。我們會協助評估資格、準備申請文件及跟進申請進度。',
        },
        {
          question: '工程報價包括什麼？',
          answer: '我們的報價包括設計費、工程費、物料費及管理費。會詳細列明各項工程內容及費用，不會有隱藏收費。如需額外項目，會先徵得院舍同意才進行。我們也提供分期付款安排，減輕院舍的財政壓力。',
        },
        {
          question: '工程需要多長時間？',
          answer: '視乎工程規模而定。小型改善工程一般需要 2-4 週，中型翻新約 2-3 個月，大型全面翻新則需要 4-6 個月。我們會在開工前提供詳細的工程時間表，並盡力按時完成。',
        },
        {
          question: '完工後有保養服務嗎？',
          answer: '有的。所有工程都提供 12 個月的保養期，期間如有任何工程問題，我們會免費維修。我們也提供延長保養服務，讓院舍更安心。',
        },
      ]}
      ctaTitle="立即預約免費諮詢"
      ctaDescription="我們的專業團隊將為您的院舍提供免費實地評估，制定最合適的改善工程方案，歡迎聯絡我們了解更多。"
    />
  );
}
